import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import TopBar from './components/TopBar';
import Header from './components/Header';
import Hero from './components/Hero';
import Configurator from './components/Configurator';
import Moments from './components/Moments';
import Technology from './components/Technology';
import LakeLife from './components/LakeLife';
import Packages from './components/Packages';
import References from './components/References';
import CTASection from './components/CTASection';
import CallButton from './components/CallButton';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';

function HomePage() {
  return (
    <>
      <TopBar />
      <Header />
      <Hero />
      <Configurator id="survey" />
      <Moments />
      <Technology />
      <LakeLife />
      <Packages />
      <References />
      <Configurator id="survey-2" />
      <CTASection />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/adatvedelem" element={<PrivacyPolicy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
        </Routes>
        <CallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
